import { IBackInDownContainerProps } from '@component/BackInDown';
import { IBackInLeftContainerProps } from '@component/BackInLeft';
import { IBackInRightContainerProps } from '@component/BackInRight';
import { IBackInUpContainerProps } from '@component/BackInUp';

import { IBackOutDownContainerProps } from '@component/BackOutDown';
import { IBackOutLeftContainerProps } from '@component/BackOutLeft';
import { IBackOutRightContainerProps } from '@component/BackOutRight';
import { IBackOutUpContainerProps } from '@component/BackOutUp';

import { IBounceContainerProps } from '@component/Bounce';
import { IBounceInContainerProps } from '@component/BounceIn';
import { IBounceInDownContainerProps } from '@component/BounceInDown';
import { IBounceInLeftContainerProps } from '@component/BounceInLeft';
import { IBounceInRightContainerProps } from '@component/BounceInRight';
import { IBounceInUpContainerProps } from '@component/BounceInUp';

import { IBounceOutContainerProps } from '@component/BounceOut';
import { IBounceOutDownContainerProps } from '@component/BounceOutDown';
import { IBounceOutLeftContainerProps } from '@component/BounceOutLeft';
import { IBounceOutRightContainerProps } from '@component/BounceOutRight';
import { IBounceOutUpContainerProps } from '@component/BounceOutUp';

import { IFadeInContainerProps } from '@component/FadeIn';
import { IFadeInBottomLeftContainerProps } from '@component/FadeInBottomLeft';
import { IFadeInBottomRightContainerProps } from '@component/FadeInBottomRight';
import { IFadeInDownContainerProps } from '@component/FadeInDown';
import { IFadeInLeftContainerProps } from '@component/FadeInLeft';
import { IFadeInRightContainerProps } from '@component/FadeInRight';
import { IFadeInTopLeftContainerProps } from '@component/FadeInTopLeft';
import { IFadeInTopRightContainerProps } from '@component/FadeInTopRight';
import { IFadeInUpContainerProps } from '@component/FadeInUp';

import { IFadeOutContainerProps } from '@component/FadeOut';
import { IFadeOutBottomLeftContainerProps } from '@component/FadeOutBottomLeft';
import { IFadeOutBottomRightContainerProps } from '@component/FadeOutBottomRight';
import { IFadeOutDownContainerProps } from '@component/FadeOutDown';
import { IFadeOutLeftContainerProps } from '@component/FadeOutLeft';
import { IFadeOutRightContainerProps } from '@component/FadeOutRight';
import { IFadeOutTopLeftContainerProps } from '@component/FadeOutTopLeft';
import { IFadeOutTopRightContainerProps } from '@component/FadeOutTopRight';
import { IFadeOutUpContainerProps } from '@component/FadeOutUp';

import { IFlashContainerProps } from '@component/Flash';
import { IFlipContainerProps } from '@component/Flip';
import { IFlipInXContainerProps } from '@component/FlipInX';
import { IFlipInYContainerProps } from '@component/FlipInY';
import { IFlipOutXContainerProps } from '@component/FlipOutX';
import { IFlipOutYContainerProps } from '@component/FlipOutY';

import { IHeartBeatContainerProps } from '@component/HeartBeat';
import { IHingeContainerProps } from '@component/Hinge';
import { IJackInTheBoxContainerProps } from '@component/JackInTheBox';
import { IJelloContainerProps } from '@component/Jello';

import { ILightSpeedInLeftContainerProps } from '@component/LightSpeedInLeft';
import { ILightSpeedInRightContainerProps } from '@component/LightSpeedInRight';
import { ILightSpeedOutLeftContainerProps } from '@component/LightSpeedOutLeft';
import { ILightSpeedOutRightContainerProps } from '@component/LightSpeedOutRight';

import { IPulseContainerProps } from '@component/Pulse';
import { IRollInContainerProps } from '@component/RollIn';
import { IRollOutContainerProps } from '@component/RollOut';

import { IRotateInContainerProps } from '@component/RotateIn';
import { IRotateInDownLeftContainerProps } from '@component/RotateInDownLeft';
import { IRotateInDownRightContainerProps } from '@component/RotateInDownRight';
import { IRotateInUpLeftContainerProps } from '@component/RotateInUpLeft';
import { IRotateInUpRightContainerProps } from '@component/RotateInUpRight';

import { IRotateOutContainerProps } from '@component/RotateOut';
import { IRotateOutDownLeftContainerProps } from '@component/RotateOutDownLeft';
import { IRotateOutDownRightContainerProps } from '@component/RotateOutDownRight';
import { IRotateOutUpLeftContainerProps } from '@component/RotateOutUpLeft';
import { IRotateOutUpRightContainerProps } from '@component/RotateOutUpRight';

import { IRubberBandContainerProps } from '@component/RubberBand';
import { IShakeXContainerProps } from '@component/ShakeX';
import { IShakeYContainerProps } from '@component/ShakeY';
import { ISlideInDownContainerProps } from '@component/SlideInDown';
import { ISlideInLeftContainerProps } from '@component/SlideInLeft';
import { ISlideInRightContainerProps } from '@component/SlideInRight';
import { ISlideInUpContainerProps } from '@component/SlideInUp';

import { ISlideOutDownContainerProps } from '@component/SlideOutDown';
import { ISlideOutLeftContainerProps } from '@component/SlideOutLeft';
import { ISlideOutRightContainerProps } from '@component/SlideOutRight';
import { ISlideOutUpContainerProps } from '@component/SlideOutUp';

import { ISwingContainerProps } from '@component/Swing';
import { ITadaContainerProps } from '@component/Tada';
import { IWobbleContainerProps } from '@component/Wobble';

import { IZoomInContainerProps } from '@component/ZoomIn';
import { IZoomInDownContainerProps } from '@component/ZoomInDown';
import { IZoomInLeftContainerProps } from '@component/ZoomInLeft';
import { IZoomInRightContainerProps } from '@component/ZoomInRight';
import { IZoomInUpContainerProps } from '@component/ZoomInUp';

import { IZoomOutContainerProps } from '@component/ZoomOut';
import { IZoomOutDownContainerProps } from '@component/ZoomOutDown';
import { IZoomOutLeftContainerProps } from '@component/ZoomOutLeft';
import { IZoomOutRightContainerProps } from '@component/ZoomOutRight';
import { IZoomOutUpContainerProps } from '@component/ZoomOutUp';

// TYPE EXPORT
export type IBackInDownProps = IBackInDownContainerProps;
export type IBackInLeftProps = IBackInLeftContainerProps;
export type IBackInRightProps = IBackInRightContainerProps;
export type IBackInUpProps = IBackInUpContainerProps;

export type IBackOutDownProps = IBackOutDownContainerProps;
export type IBackOutLeftProps = IBackOutLeftContainerProps;
export type IBackOutRightProps = IBackOutRightContainerProps;
export type IBackOutUpProps = IBackOutUpContainerProps;

export type IBounceProps = IBounceContainerProps;
export type IBounceInProps = IBounceInContainerProps;
export type IBounceInDownProps = IBounceInDownContainerProps;
export type IBounceInLeftProps = IBounceInLeftContainerProps;
export type IBounceInRightProps = IBounceInRightContainerProps;
export type IBounceInUpProps = IBounceInUpContainerProps;

export type IBounceOutProps = IBounceOutContainerProps;
export type IBounceOutDownProps = IBounceOutDownContainerProps;
export type IBounceOutLeftProps = IBounceOutLeftContainerProps;
export type IBounceOutRightProps = IBounceOutRightContainerProps;
export type IBounceOutUpProps = IBounceOutUpContainerProps;

export type IFadeInProps = IFadeInContainerProps;
export type IFadeInBottomLeftProps = IFadeInBottomLeftContainerProps;
export type IFadeInBottomRightProps = IFadeInBottomRightContainerProps;
export type IFadeInDownProps = IFadeInDownContainerProps;
export type IFadeInLeftProps = IFadeInLeftContainerProps;
export type IFadeInRightProps = IFadeInRightContainerProps;
export type IFadeInTopLeftProps = IFadeInTopLeftContainerProps;
export type IFadeInTopRightProps = IFadeInTopRightContainerProps;
export type IFadeInUpProps = IFadeInUpContainerProps;

export type IFadeOutProps = IFadeOutContainerProps;
export type IFadeOutBottomLeftProps = IFadeOutBottomLeftContainerProps;
export type IFadeOutBottomRightProps = IFadeOutBottomRightContainerProps;
export type IFadeOutDownProps = IFadeOutDownContainerProps;
export type IFadeOutLeftProps = IFadeOutLeftContainerProps;
export type IFadeOutRightProps = IFadeOutRightContainerProps;
export type IFadeOutTopLeftProps = IFadeOutTopLeftContainerProps;
export type IFadeOutTopRightProps = IFadeOutTopRightContainerProps;
export type IFadeOutUpProps = IFadeOutUpContainerProps;

export type IFlashProps = IFlashContainerProps;
export type IFlipProps = IFlipContainerProps;
export type IFlipInXProps = IFlipInXContainerProps;
export type IFlipInYProps = IFlipInYContainerProps;
export type IFlipOutXProps = IFlipOutXContainerProps;
export type IFlipOutYProps = IFlipOutYContainerProps;

export type IHeartBeatProps = IHeartBeatContainerProps;
export type IHingeProps = IHingeContainerProps;
export type IJackInTheBoxProps = IJackInTheBoxContainerProps;
export type IJelloProps = IJelloContainerProps;

export type ILightSpeedInLeftProps = ILightSpeedInLeftContainerProps;
export type ILightSpeedInRightProps = ILightSpeedInRightContainerProps;
export type ILightSpeedOutLeftProps = ILightSpeedOutLeftContainerProps;
export type ILightSpeedOutRightProps = ILightSpeedOutRightContainerProps;

export type IPulseProps = IPulseContainerProps;
export type IRollInProps = IRollInContainerProps;
export type IRollOutProps = IRollOutContainerProps;

export type IRotateInProps = IRotateInContainerProps;
export type IRotateInDownLeftProps = IRotateInDownLeftContainerProps;
export type IRotateInDownRightProps = IRotateInDownRightContainerProps;
export type IRotateInUpLeftProps = IRotateInUpLeftContainerProps;
export type IRotateInUpRightProps = IRotateInUpRightContainerProps;

export type IRotateOutProps = IRotateOutContainerProps;
export type IRotateOutDownLeftProps = IRotateOutDownLeftContainerProps;
export type IRotateOutDownRightProps = IRotateOutDownRightContainerProps;
export type IRotateOutUpLeftProps = IRotateOutUpLeftContainerProps;
export type IRotateOutUpRightProps = IRotateOutUpRightContainerProps;

export type IRubberBandProps = IRubberBandContainerProps;
export type IShakeXProps = IShakeXContainerProps;
export type IShakeYProps = IShakeYContainerProps;
export type ISlideInDownProps = ISlideInDownContainerProps;
export type ISlideInLeftProps = ISlideInLeftContainerProps;
export type ISlideInRightProps = ISlideInRightContainerProps;
export type ISlideInUpProps = ISlideInUpContainerProps;

export type ISlideOutDownProps = ISlideOutDownContainerProps;
export type ISlideOutLeftProps = ISlideOutLeftContainerProps;
export type ISlideOutRightProps = ISlideOutRightContainerProps;
export type ISlideOutUpProps = ISlideOutUpContainerProps;

export type ISwingProps = ISwingContainerProps;
export type ITadaProps = ITadaContainerProps;
export type IWobbleProps = IWobbleContainerProps;

export type IZoomInProps = IZoomInContainerProps;
export type IZoomInDownProps = IZoomInDownContainerProps;
export type IZoomInLeftProps = IZoomInLeftContainerProps;
export type IZoomInRightProps = IZoomInRightContainerProps;
export type IZoomInUpProps = IZoomInUpContainerProps;

export type IZoomOutProps = IZoomOutContainerProps;
export type IZoomOutDownProps = IZoomOutDownContainerProps;
export type IZoomOutLeftProps = IZoomOutLeftContainerProps;
export type IZoomOutRightProps = IZoomOutRightContainerProps;
export type IZoomOutUpProps = IZoomOutUpContainerProps;

// COMPONENT EXPORT
export { BackInDown } from '@component/BackInDown';
export { BackInLeft } from '@component/BackInLeft';
export { BackInRight } from '@component/BackInRight';
export { BackInUp } from '@component/BackInUp';

export { BackOutDown } from '@component/BackOutDown';
export { BackOutLeft } from '@component/BackOutLeft';
export { BackOutRight } from '@component/BackOutRight';
export { BackOutUp } from '@component/BackOutUp';

export { Bounce } from '@component/Bounce';
export { BounceIn } from '@component/BounceIn';
export { BounceInDown } from '@component/BounceInDown';
export { BounceInLeft } from '@component/BounceInLeft';
export { BounceInRight } from '@component/BounceInRight';
export { BounceInUp } from '@component/BounceInUp';

export { BounceOut } from '@component/BounceOut';
export { BounceOutDown } from '@component/BounceOutDown';
export { BounceOutLeft } from '@component/BounceOutLeft';
export { BounceOutRight } from '@component/BounceOutRight';
export { BounceOutUp } from '@component/BounceOutUp';

export { FadeIn } from '@component/FadeIn';
export { FadeInBottomLeft } from '@component/FadeInBottomLeft';
export { FadeInBottomRight } from '@component/FadeInBottomRight';
export { FadeInDown } from '@component/FadeInDown';
export { FadeInLeft } from '@component/FadeInLeft';
export { FadeInRight } from '@component/FadeInRight';
export { FadeInTopLeft } from '@component/FadeInTopLeft';
export { FadeInTopRight } from '@component/FadeInTopRight';
export { FadeInUp } from '@component/FadeInUp';

export { FadeOut } from '@component/FadeOut';
export { FadeOutBottomLeft } from '@component/FadeOutBottomLeft';
export { FadeOutBottomRight } from '@component/FadeOutBottomRight';
export { FadeOutDown } from '@component/FadeOutDown';
export { FadeOutLeft } from '@component/FadeOutLeft';
export { FadeOutRight } from '@component/FadeOutRight';
export { FadeOutTopLeft } from '@component/FadeOutTopLeft';
export { FadeOutTopRight } from '@component/FadeOutTopRight';
export { FadeOutUp } from '@component/FadeOutUp';

export { Flash } from '@component/Flash';
export { Flip } from '@component/Flip';
export { FlipInX } from '@component/FlipInX';
export { FlipInY } from '@component/FlipInY';
export { FlipOutX } from '@component/FlipOutX';
export { FlipOutY } from '@component/FlipOutY';

export { HeartBeat } from '@component/HeartBeat';
export { Hinge } from '@component/Hinge';
export { JackInTheBox } from '@component/JackInTheBox';
export { Jello } from '@component/Jello';

export { LightSpeedInLeft } from '@component/LightSpeedInLeft';
export { LightSpeedInRight } from '@component/LightSpeedInRight';
export { LightSpeedOutLeft } from '@component/LightSpeedOutLeft';
export { LightSpeedOutRight } from '@component/LightSpeedOutRight';

export { Pulse } from '@component/Pulse';
export { RollIn } from '@component/RollIn';
export { RollOut } from '@component/RollOut';

export { RotateIn } from '@component/RotateIn';
export { RotateInDownLeft } from '@component/RotateInDownLeft';
export { RotateInDownRight } from '@component/RotateInDownRight';
export { RotateInUpLeft } from '@component/RotateInUpLeft';
export { RotateInUpRight } from '@component/RotateInUpRight';

export { RotateOut } from '@component/RotateOut';
export { RotateOutDownLeft } from '@component/RotateOutDownLeft';
export { RotateOutDownRight } from '@component/RotateOutDownRight';
export { RotateOutUpLeft } from '@component/RotateOutUpLeft';
export { RotateOutUpRight } from '@component/RotateOutUpRight';

export { RubberBand } from '@component/RubberBand';
export { ShakeX } from '@component/ShakeX';
export { ShakeY } from '@component/ShakeY';
export { SlideInDown } from '@component/SlideInDown';
export { SlideInLeft } from '@component/SlideInLeft';
export { SlideInRight } from '@component/SlideInRight';
export { SlideInUp } from '@component/SlideInUp';

export { SlideOutDown } from '@component/SlideOutDown';
export { SlideOutLeft } from '@component/SlideOutLeft';
export { SlideOutRight } from '@component/SlideOutRight';
export { SlideOutUp } from '@component/SlideOutUp';

export { Swing } from '@component/Swing';
export { Tada } from '@component/Tada';
export { Wobble } from '@component/Wobble';

export { ZoomIn } from '@component/ZoomIn';
export { ZoomInDown } from '@component/ZoomInDown';
export { ZoomInLeft } from '@component/ZoomInLeft';
export { ZoomInRight } from '@component/ZoomInRight';
export { ZoomInUp } from '@component/ZoomInUp';

export { ZoomOut } from '@component/ZoomOut';
export { ZoomOutDown } from '@component/ZoomOutDown';
export { ZoomOutLeft } from '@component/ZoomOutLeft';
export { ZoomOutRight } from '@component/ZoomOutRight';
export { ZoomOutUp } from '@component/ZoomOutUp';
